import React from 'react';
import { CheckCircle2, Lock, Package, Shield, Zap, Crown } from 'lucide-react';
export function FinalCTASection() {
  return <section id="compra" className="bg-black py-24 px-4 border-t-4 border-neon scroll-mt-20" data-id="element-105">
      <div className="max-w-4xl mx-auto" data-id="element-106">
        <h2 className="text-4xl md:text-6xl font-extrabold text-white text-center leading-tight mb-16 font-montserrat" data-id="element-107">
          "Todo lo que Recibes Hoy"
        </h2>

        <div className="bg-gray-900 rounded-3xl border-2 border-gray-800 p-8 md:p-12 shadow-2xl mb-16 max-w-2xl mx-auto" data-id="element-108">
          <ul className="space-y-6" data-id="element-109">
            <li className="flex items-center gap-4 text-white text-lg md:text-xl" data-id="element-110">
              <CheckCircle2 className="w-8 h-8 text-neon shrink-0" data-id="element-111" />
              <span className="font-bold flex-grow" data-id="element-112">
                Tomo 1: El Mercado Invisible
              </span>
              <span className="text-gray-500 italic text-sm md:text-base whitespace-nowrap" data-id="element-113">
                (Valor: 47€)
              </span>
            </li>
            <li className="flex items-center gap-4 text-white text-lg md:text-xl" data-id="element-114">
              <CheckCircle2 className="w-8 h-8 text-neon shrink-0" data-id="element-115" />
              <span className="font-bold flex-grow" data-id="element-116">
                Tomo 2: Tu Estudio por 0€
              </span>
              <span className="text-gray-500 italic text-sm md:text-base whitespace-nowrap" data-id="element-117">
                (Valor: 47€)
              </span>
            </li>
            <li className="flex items-center gap-4 text-white text-lg md:text-xl" data-id="element-118">
              <CheckCircle2 className="w-8 h-8 text-neon shrink-0" data-id="element-119" />
              <span className="font-bold flex-grow" data-id="element-120">
                Tomo 3: El Video que Vende
              </span>
              <span className="text-gray-500 italic text-sm md:text-base whitespace-nowrap" data-id="element-121">
                (Valor: 67€)
              </span>
            </li>
            <li className="flex items-center gap-4 text-white text-lg md:text-xl" data-id="element-122">
              <CheckCircle2 className="w-8 h-8 text-neon shrink-0" data-id="element-123" />
              <span className="font-bold flex-grow" data-id="element-124">
                Tomo 4: El Radar de Marcas
              </span>
              <span className="text-gray-500 italic text-sm md:text-base whitespace-nowrap" data-id="element-125">
                (Valor: 67€)
              </span>
            </li>
            <li className="flex items-center gap-4 text-white text-lg md:text-xl" data-id="element-126">
              <CheckCircle2 className="w-8 h-8 text-neon shrink-0" data-id="element-127" />
              <span className="font-bold flex-grow" data-id="element-128">
                Tomo 5: De 500€ a 2.000€
              </span>
              <span className="text-gray-500 italic text-sm md:text-base whitespace-nowrap" data-id="element-129">
                (Valor: 67€)
              </span>
            </li>

            <div className="h-px bg-gray-800 my-6" data-id="element-130"></div>

            <li className="flex items-center gap-4 text-white text-lg md:text-xl" data-id="element-131">
              <CheckCircle2 className="w-8 h-8 text-orange-500 shrink-0" data-id="element-132" />
              <span className="font-bold text-orange-500 flex-grow" data-id="element-133">
                Bono 1: UGC Starter Kit Express 48H
              </span>
              <span className="text-gray-500 italic text-sm md:text-base whitespace-nowrap" data-id="element-134">
                (Valor: 47€)
              </span>
            </li>
            <li className="flex items-center gap-4 text-white text-lg md:text-xl" data-id="element-135">
              <CheckCircle2 className="w-8 h-8 text-orange-500 shrink-0" data-id="element-136" />
              <span className="font-bold text-orange-500 flex-grow" data-id="element-137">
                Bono 2: Biblioteca Anti-Rechazo
              </span>
              <span className="text-gray-500 italic text-sm md:text-base whitespace-nowrap" data-id="element-138">
                (Valor: 47€)
              </span>
            </li>
            <li className="flex items-center gap-4 text-white text-lg md:text-xl" data-id="element-139">
              <CheckCircle2 className="w-8 h-8 text-orange-500 shrink-0" data-id="element-140" />
              <span className="font-bold text-orange-500 flex-grow" data-id="element-141">
                Bono 3: Calendario 30D Ingreso Extra
              </span>
              <span className="text-gray-500 italic text-sm md:text-base whitespace-nowrap" data-id="element-142">
                (Valor: 47€)
              </span>
            </li>

            <div className="h-px bg-gray-800 my-6" data-id="element-143"></div>

            <li className="flex items-center gap-4 text-white text-lg md:text-xl" data-id="element-144">
              <CheckCircle2 className="w-8 h-8 text-neon shrink-0" data-id="element-145" />
              <span className="font-bold text-neon flex-grow" data-id="element-146">
                Garantía 30 días sin preguntas
              </span>
              <span className="text-gray-500 italic text-sm md:text-base whitespace-nowrap" data-id="element-147">
                (Valor: Tranquilidad)
              </span>
            </li>
          </ul>
        </div>

        {/* Dual Purchase Options */}
        <div className="max-w-2xl mx-auto space-y-6 mb-12" data-id="element-148">
          {/* OPTION 1: Upsell — Primary */}
          <div className="bg-gray-900 border-4 border-neon rounded-2xl p-6 md:p-8 shadow-neon-lg relative" data-id="element-149">
            <div className="absolute -top-4 left-1/2 transform -translate-x-1/2 bg-neon text-black font-black text-sm px-6 py-1 rounded-full flex items-center gap-2" data-id="element-150">
              <Crown className="w-4 h-4" data-id="element-151" />
              MEJOR OFERTA — AHORRA 3X TIEMPO
            </div>

            <div className="text-center mt-4 mb-6" data-id="element-152">
              <h3 className="text-2xl md:text-3xl font-black text-white mb-2" data-id="element-153">
                El Método 500€ + Pack Acelerador Pro
              </h3>
              <p className="text-gray-400 text-sm" data-id="element-154">
                Todo el sistema + guiones listos + prospección + guía legal +
                media kit pro
              </p>
              <div className="mt-4" data-id="element-155">
                <span className="text-gray-500 line-through text-2xl mr-3" data-id="element-156">
                  436€
                </span>
                <span className="text-neon text-5xl md:text-6xl font-black" data-id="element-157">
                  24.99€
                </span>
              </div>
            </div>

            <button type="button" onClick={() => window.open('https://pagos.digipromarket.com/cart/56260096786758:1', '_blank', 'noopener,noreferrer')} className="w-full bg-neon text-black font-extrabold text-xl md:text-2xl py-5 md:py-6 px-4 rounded-xl border-4 border-black animate-pulse-neon hover:bg-[#32e612] transition-colors flex flex-col items-center justify-center gap-2 cursor-pointer" data-id="element-158">
              <div className="flex items-center gap-2 text-center" data-id="element-159">
                <Zap className="w-7 h-7 fill-black shrink-0" data-id="element-160" />
                <span data-id="element-161">SÍ, QUIERO TODO POR 24.99€</span>
              </div>
              <span className="text-sm font-bold opacity-80" data-id="element-162">
                👇 ACCESO INMEDIATO — PACK COMPLETO
              </span>
            </button>
          </div>

          {/* OPTION 2: Base — Secondary */}
          <div className="bg-gray-900 border-2 border-gray-700 rounded-2xl p-6 md:p-8" data-id="element-163">
            <div className="text-center mb-6" data-id="element-164">
              <h3 className="text-xl md:text-2xl font-bold text-gray-300 mb-2" data-id="element-165">
                Solo El Método 500€
              </h3>
              <p className="text-gray-500 text-sm" data-id="element-166">
                Los 5 tomos + 3 bonos + garantía 30 días
              </p>
              <div className="mt-4" data-id="element-167">
                <span className="text-gray-500 line-through text-xl mr-3" data-id="element-168">
                  295€
                </span>
                <span className="text-white text-4xl md:text-5xl font-black" data-id="element-169">
                  17.99€
                </span>
              </div>
            </div>

            <button type="button" onClick={() => window.open('https://pagos.digipromarket.com/cart/56260071653702:1', '_blank', 'noopener,noreferrer')} className="w-full bg-white text-black font-extrabold text-lg md:text-xl py-4 px-4 rounded-xl border-2 border-gray-300 hover:border-neon hover:shadow-neon transition-all flex flex-col items-center justify-center gap-1 cursor-pointer" data-id="element-170">
              <div className="flex items-center gap-2 text-center" data-id="element-171">
                <Zap className="w-5 h-5 fill-black shrink-0" data-id="element-172" />
                <span data-id="element-173">QUIERO EL MÉTODO 500€ — 17.99€</span>
              </div>
              <span className="text-xs text-gray-500" data-id="element-174">
                Sin Pack Acelerador Pro
              </span>
            </button>
          </div>
        </div>

        <div className="flex flex-col md:flex-row items-center justify-center gap-6 text-gray-400 font-medium" data-id="element-175">
          <div className="flex items-center gap-2" data-id="element-176">
            <Lock className="w-5 h-5" data-id="element-177" />
            <span data-id="element-178">Pago 100% Seguro</span>
          </div>
          <div className="hidden md:block w-1 h-1 bg-gray-600 rounded-full" data-id="element-179"></div>
          <div className="flex items-center gap-2" data-id="element-180">
            <Package className="w-5 h-5" data-id="element-181" />
            <span data-id="element-182">Acceso Inmediato</span>
          </div>
          <div className="hidden md:block w-1 h-1 bg-gray-600 rounded-full" data-id="element-183"></div>
          <div className="flex items-center gap-2" data-id="element-184">
            <Shield className="w-5 h-5" data-id="element-185" />
            <span data-id="element-186">Garantía 30 Días</span>
          </div>
        </div>
      </div>
    </section>;
}